// extracted by mini-css-extract-plugin
module.exports = {"back-close":"style__back-close--2rL7u","inner-content":"style__inner-content--2fyH-","close-tip":"style__close-tip--2vMC2","close-btn":"style__close-btn--1uQ_H"};